import { render, staticRenderFns } from "./PromotionDetail.vue?vue&type=template&id=b2c66d3c&"
import script from "./PromotionDetail.vue?vue&type=script&lang=js&"
export * from "./PromotionDetail.vue?vue&type=script&lang=js&"
import style0 from "./PromotionDetail.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports